import turfObj from "@turf/distance";

export default function distance(point1, point2, options) {
    return turfObj(point1, point2, options);
};
